<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Active Memries</h4>
            <p class="category">This is like looking inside your brain!</p>
          </md-card-header>
          <md-card-content>
            <div class="loader" v-if="showmemries == null">
               <ring-loader :loading="true" color="orange" ></ring-loader>
            </div>
           <!--
            <div><md-button class="md-none md-round md-small" @click="getShowTags(currtag.parentid)" v-if="currtag != null">
                <i class="material-icons">
                  keyboard_arrow_left
                  </i> {{currtag.path}}
              </md-button>
            </div>
            
            <div class="md-autocomplete" style="width: 120px;">
              <div class="md-field md-autocomplete search md-theme-default md-clearable md-has-value">
                <div class="md-menu"><input type="text" v-model="tagfilter" @keyup="filterTags" id="md-input-hox50oawp" class="md-input"> </div> 
                <label>Filter Tags...</label> <button type="button" class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default" tabindex="-1"><div class="md-ripple"><div class="md-button-content" @click="filterTags(true)"><i class="md-icon md-icon-font md-icon-image md-theme-default"><svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path> <path d="M0 0h24v24H0z" fill="none"></path></svg></i></div> </div></button>
            </div>
            </div>
            -->

            <div class="md-autocomplete" style="width: 120px;display: inline-block;">
              <div class="md-field md-autocomplete search md-theme-default md-clearable">
                <div class="md-menu">
                  <input placeholder="Search..." type="text" id="md-input-xf4tqgymk" class="md-input" v-model="search"  v-on:keyup.enter="onSearch">
               </div> 
               
               </div>
               </div>
              <button type="button" class="md-button md-raised md-success md-theme-default" @click="onSearch"><div class="md-ripple"><div class="md-button-content">Search</div> </div></button>
          <!--
            <select name="chooselimit">
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
-->
              <div class="md-autocomplete" style="float:right;width:120px;margin-left:50px;display:inline-block;">
            <md-autocomplete
              class="search"
              v-model="memryfilter"
              :md-options="emptylist"
             
            >
              <label>Filter Memries...</label>
            </md-autocomplete>
            </div>  

             <div class="md-autocomplete" style="float:right;width:120px;display:inline-block;">
            <md-autocomplete
              class="search"
              v-model="tagfilter"
              :md-options="emptylist"
             
            >
              <label>Filter Tags...</label>
            </md-autocomplete>
            </div>  
            
           <div>
             <div style="font-weight:bold">
               Showing {{limit}} most recent memries<span v-if="searched"> with keyword '{{searched}}'</span>.
             </div>
              <md-table v-if="showmemries != null" v-model="showmemries">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Topic/Source">{{ item.question }}</md-table-cell>
                    <md-table-cell md-label="Tags"><md-button class="md-info md-round md-xsmall" @click="getShowTagsByPath(tag)" v-for="tag in item.tagpaths" v-bind:key="tag">
                          {{tag}}
                        </md-button>
                    </md-table-cell>
                  <md-table-cell md-label="Review Type">{{item.type == 0 ? 'Summary' : 'Source' }}</md-table-cell>
                  <md-table-cell md-label="Start">{{ item.datecreatedlbl }}<span style="display:none">{{item.datecreated}}</span></md-table-cell>
                  <md-table-cell md-label="Due">{{ item.duedatelbl }}<span style="display:none">{{item.duedate}}</span></md-table-cell>
                  <md-table-cell md-label="Last Scored">{{ item.lastreviewedlbl }}</md-table-cell>
                   <md-table-cell>
                    <router-link :to="{ name: 'Update Memry',params: { id: item.id } }" > 
                        <i class="md-icon md-icon-font md-theme-default" style="float:right;cursor:pointer;" >edit</i>
                    </router-link>
                   </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </md-card-content>
        </md-card>
      </div>

       
    <!--
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card class="md-card-plain">
          <md-card-header data-background-color="green">
            <h4 class="title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </md-card-header>
          <md-card-content>
            <ordered-table></ordered-table>
          </md-card-content>
        </md-card>
      </div>  -->
    </div>
    
  </div>

</template>

<script>
import { SimpleTable } from "@/components";
import ApiService from "@/services/api.service";
import UtilService from "@/services/util.service";
import _ from "lodash";
import { RingLoader } from '@saeris/vue-spinners'

export default {
  components: {
     SimpleTable,
     RingLoader
  },
  data() {
    return {
      memries: [],
      showmemries: null,
      showtags: [],
      alltags: [],
      currtags: [],
      currtag: {},
      emptylist: [],
      tagfilter: null,
      memryfilter: null,
      memry: {},
      overduecount: 0,
      todaycount: 0,
      errorString: null,
      showAnswer: false,
      showHint: false,
      sampleSize: 20,
      sampleOnly: false,
      limit: 50,
      search: null,
      searched: null
      
    };
  },
   watch: {
        tagfilter: function(val, oldVal) {
            if((val == null || val == '') && (oldVal != undefined && val != oldVal))
              this.filterMemries(true);
              
            if(val.length > 2)
              this.filterMemries();
        },
         memryfilter: function(val, oldVal) {
            if((val == null || val == '') && (oldVal != undefined && val != oldVal))
              this.filterMemries(true);
              
            if(val.length > 2)
              this.filterMemries();
        }
    },
  mounted() {
        ApiService.getTags()
        .then(response => { 
           
           
            if(!response || response.data == null) {
              this.alltags = [];
            } else {
              this.alltags = response.data;
               console.log("Fetching Tags", response.data);
            }
            this.getMemries();
           
        });
       
  },
  methods: {
    /*
    editMemry(memry) {
        let routeData = this.$router.resolve({name: 'Update Memry', props: { updatememry: memry }});
        window.open(routeData.href, '_blank');
    },*/
    getShowTags(parentId) {

       this.currtags = _.filter(this.alltags,{parentid: parentId});
       this.showtags = this.currtags;
      this.sampleOnly = false
      if(parentId == -1) {
          this.currtag = null;
          this.memries = [];
      } else {
          this.currtag = _.find(this.alltags, {id: parentId});
          this.getMemries(this.currtag.id);
      }

       if(this.showtags.length > this.sampleSize) {
              this.showtags = this.currtags.slice(1,this.sampleSize);
              this.sampleOnly = true;
       }

       
    },
    onSearch() {
      console.log('Searching:',this.search)
      this.getMemries();
    },

    scroll () {
      window.onscroll = () => {
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.getMemries(null,null,null)
        }
      };
    },
    
    filterMemries(clear) {

        
        if((this.tagfilter == null || this.tagfilter == '') && (this.memryfilter == null || this.memryfilter == '')) {
            this.showmemries = this.memries;
        } else {
           
                this.showmemries = _.filter(this.memries, (memry) => {
                    var isMem = this.memryfilter == null || this.memryfilter == '' ? true : memry.answer.toLowerCase().includes(this.memryfilter.toLowerCase()) || memry.question.toLowerCase().includes(this.memryfilter.toLowerCase());
                    var isTag = this.tagfilter == null || this.tagfilter == '' ? true :  memry.tagpaths[0].toLowerCase().includes(this.tagfilter.toLowerCase());

                    return isMem && isTag
                    //return  tag.name.toLowerCase().includes(this.tagfilter.toLowerCase());
              })
              
        }
    },

    filterTags(clear,showall) {

         console.log('Filter');

         //limit the amount shown if showing all with no filter
          if(this.tagfilter == null || this.tagfilter == '' || clear == true) {
              this.showtags = showall ?  this.currtags : this.currtags.slice(1,this.sampleSize);
              this.tagfilter = '';
          } else {
              if(this.tagfilter.length > 2) {
                this.showtags = _.filter(this.currtags, (tag) => {
                    return  tag.name.toLowerCase().includes(this.tagfilter.toLowerCase());
              })
              }
          }

          this.sampleOnly = this.showtags.length != this.currtags.length;
          
            
    },
     getShowTagsByPath(path) {

       this.currtag = _.find(this.alltags, {path: path});
       this.currtags = _.filter(this.alltags,{parentid: this.currtag.id});
       this.tagfilter = '';
       this.showtags = this.currtags;
       this.sampleOnly = false;
       this.getMemries(this.currtag.id);
     
    },

    getMemries() {

        /*
        this.currtag = _.find(this.alltags, {id: tagid});
         this.currtags = _.filter(this.alltags,{parentid: tagid});
        this.tagfilter = '';
        this.showtags = this.currtags;
        this.sampleOnly = false;*/

        ApiService.getMemries(this.search,this.limit)
        .then(response => {
            if(!response || response.data == null) {
              this.memries = [];
            } else {
              if(this.search || this.search == '')
                this.searched = this.search != '' ? this.search : null;
           
              var listmemries = response.data;
              var memryResp = UtilService.extendMemries(listmemries,this.alltags);
              this.memries = memryResp.memries;
              this.showmemries = this.memries;
              console.log(this.memries);
            }

        })

      
    }
  }
};
</script>
